import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import bem from 'utils/bem';
import Text from 'components/Text';
import ErrorLayout from './ErrorLayout';
import { IconButton } from 'components/Button';

import './index.sass'

const { cnBlock, el } = bem('page', 'error');

const ErrorPage = () => {
    const error = useRouteError();

    let message = 'Что-то пошло не так';

    if (error.message && error.message.includes('Failed to fetch')) {
        message = 'Отсутствует подключение к интернету';
    }

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            message = 'Страница не найдена';
        }

        if (error.status === 401) {
            message = 'Вам не хватает прав для просмотра этой страницы';
        }

        if (error.status === 503) {
            message = 'Проблемы на сервере';
        }
    }

    return <ErrorLayout status={error.status} message={message} />

};

export default ErrorPage;
